import { createProvider } from '../vue-apollo';
import { isEqualTo } from '../helpers/helpers';
import envHomolog from './env.homolog';
import envProduction from './env.production';
import envDevelopment from './env.development';

const sysMode = process.env.SYS_MODE;
/**
 * Apollo Client
 * @type {any | ApolloClient<TCacheShape>}
 */
const { defaultClient } = createProvider();
const tabelaClient = createProvider().clients.tabela;
const revistaClient = createProvider().clients.revista;
const noticiaTempClient = createProvider().clients.noticiaTemp;
/**
 * Storage
 */
const storage = window.localStorage;
/**
 * CANAIS
 */
export const CANAL_ADMINISTRATIVO = 1;
export const CANAL_LOJA_PROPRIA = 5;
export const CANAL_PARCEIRO = 6;
export const CANAL_PAP = 3;
export const CANAL_TELEVENDAS = 7;
export const CANAL_PRIME = 8;
export const CANAL_OVVI = 9;

export const MIDIA_SLIDER_PRINCIPAL = 1;
export const MIDIA_INFORMATIVO_VIVO = 2;
export const MIDIA_VIVO_EM_PAUTA = 3;

const envioriement = isEqualTo(sysMode, 'homolog')
  ? envHomolog
  : isEqualTo(sysMode, 'production')
  ? envProduction
  : envDevelopment;

const env = {
  apollo: defaultClient,
  tabela: tabelaClient,
  apolloRevista: revistaClient,
  apolloNoticiaTemp: noticiaTempClient,
  token: storage.getItem('access_token'),
  revista: {
    // Canal efetivo: quando o administrador simula a visão de um canal,
    // 'canalSimulado' passa a valer para todo o portal; sem simulação,
    // usa o canal do login ('revista.canal').
    get canal() {
      return +(storage.getItem('canalSimulado') || storage.getItem('revista.canal'));
    },
    uf: storage.getItem('revista.uf'),
    modulo: storage.getItem('revista.modulo'),
  },
  canal: {
    administrativo: CANAL_ADMINISTRATIVO,
    loja_propria: CANAL_LOJA_PROPRIA,
    parceiro: CANAL_PARCEIRO,
    pap: CANAL_PAP,
    televendas: CANAL_TELEVENDAS,
    prime: CANAL_PRIME,
    ovvi: CANAL_OVVI,
  },
  ...envioriement,
};

export default env;
